import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { PackagePurchaseDrawerComponent } from './package-purchase-drawer.component';

/**
 * Opens the shared package-purchase drawer (info header + edit history) for a
 * given purchase. Used by the purchases list, the operations list, and the
 * operation-detail drawer so all three open an identical surface. No-op when no
 * purchase id is supplied (e.g. a pre-migration operation with no link).
 */
export function openPackagePurchaseDrawer(
  drawerService: NzDrawerService,
  purchaseId: string | null | undefined
): void {
  if (!purchaseId) return;
  drawerService.create<PackagePurchaseDrawerComponent, { purchaseId: string }>({
    nzTitle: 'პაკეტის ისტორია',
    nzContent: PackagePurchaseDrawerComponent,
    nzData: { purchaseId },
    nzWidth: 720,
    nzWrapClassName: 'package-drawer',
  });
}
